import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { ThemeChangeProvider } from "./Context/ThemeContext";

import { LanguageContextProvider } from "./Context/LanguageContext";
import { GlobalSpinnerContextProvider } from "./Context/GlobalSpinnerContext";
import { SidebarManagementContextProvider } from "./Context/SidebarManagementContext";
import { AuthContextProvider } from "./Context/AuthContext";
import { LicenseInfo } from "@mui/x-license-pro";

LicenseInfo.setLicenseKey(
  "d0431ab51623dca772acbfe63bdffd7cTz0xMTk1MDIsRT0xNzkwMjk0Mzk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj0yMDIyLEtWPTI=",
);

const root = createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <ThemeChangeProvider>
    <HashRouter>
      <GlobalSpinnerContextProvider>
        <LanguageContextProvider>
          <SidebarManagementContextProvider>
            <AuthContextProvider>
              <App />
            </AuthContextProvider>
          </SidebarManagementContextProvider>
        </LanguageContextProvider>
      </GlobalSpinnerContextProvider>
    </HashRouter>
  </ThemeChangeProvider>,
  // </React.StrictMode>,
);
// }
